const ENTITY_TYPES = {
  JOB: 'job',
  WORKER: 'worker',
  DATASET: 'dataset',
  MODEL: 'model',
  CHECKPOINT: 'checkpoint',
  VOLUME: 'volume',
};
export default ENTITY_TYPES;
